import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
Vue.use(Vuex)
import DialogVue from '@/util/dialog.js';
import * as echarts from "echarts" //引入echarts
Vue.prototype.$echarts = echarts
Vue.use(DialogVue);
import '@/util/common.css'
import '@/util/vant'
import '@/util/iconfont.css'//引入iconfont样式文件
Vue.config.productionTip = false
import global from './components/global'
Vue.prototype.GLOBAL = global //this.GLOBAL.test
Vue.config.ignoredElements = ['wx-open-launch-weapp']
import wx from 'weixin-js-sdk';//引入
Vue.prototype.wx = wx
import { get, post, getToken, getQueryVariableAll, listener,initMsgNum , } from './util/http'
import '@/util/mailExpress.css'
import './util/common'
import 'default-passive-events'//引入被动事件监听器
import myDirective from '@/util/myDirective';//全局引入节流函数
Vue.use(myDirective);
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.getToken = getToken;
Vue.prototype.getQueryVariableAll = getQueryVariableAll;
Vue.prototype.listener = listener;
Vue.prototype.initMsgNum = initMsgNum;
const store = new Vuex.Store({
  state: {
    count: 0,
    pathname: 'one',
    suspensionShow: true,
    badgeNum: 0,
    skinType:'normal',
  }
})
let myvue = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')